<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do Compilador C/C++</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>Como comentei, o compilador C/C++ é uma exigência do Wails.</p>
            <p>
              Apesar de ser neste primeiro momento apenas uma exigência do Wails, adicionalmente teremos instalado um compilador C/C++ totalmente
              gratuito, disponível para nosso uso. Não vou entrar em detalhes, mas podemos inserir rotinas em C/C++ em programas em Go,
              o que pode vir a ser necessário, dependendo do que queremos que o nosso sistema faça.
            </p>
            <p>
              O Wails indica um compilador específico, que é o qual iremos instalar. Basta navegarmos até
              <a
                target="_blank"
                href="http://tdm-gcc.tdragon.net/download"
              >seu site</a> e fazer o download de seu instalador.
            </p>
          </v-col>

          <v-col class="col-6 offset-3">
            <v-img src="@/assets/GCC.jpg"></v-img>
          </v-col>

          <v-col class="mt-3 col-10 offset-1">
            <p>
              Apenas os dois primeiros links são de nosso interesse. O primeiro baixa a versão de 32 bits, e o segundo, a de 64 bits. Qual escolher é
              indiferente. Particularmente, como a minha máquina de desenvolvimento é de 64 bits, eu instalo a versão de 64 bits, até mesmo porque ela
              tem a capacidade de compilar código 32 bits.
            </p>
            <p>Após o download, executar o instalador.</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/installgo">Instalação do Go</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Installc",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
